<div class="input-container">
  <div class="top no-print">
    <div class="header-contents">
      <div class="filters-section">
        <app-custom-date-select
          [(ngModel)]="selectedDate"
          class="date-select"
          [minDate]="minDate"
          [maxDate]="maxDate"
          selectionMode="month-year"
          (dateChange)="onDateSelected($event)"
        />
      </div>
      <div class="export-container">
        <button class="instructions" (click)="getInstructions()">
          <img src="assets/images/download.svg" /> Instructions
        </button>
      </div>
    </div>
    @if (isFinal) {
      <p class="final-status">
        Warning - Composite for this month has already been finalized. Making
        changes to this input sheet will not automatically reflect on the
        finalized composite.
      </p>
    }
  </div>
  @if (showErrorPage) {
    <div class="error-page">
      <app-error-page [statusCode]="statusCode" />
    </div>
  } @else {
    @if (successMessage) {
      <p class="success">{{ successMessage }}</p>
    }
    @if (errorMessage) {
      <p class="error">{{ errorMessage }}</p>
    }

    <div class="sheet-content" id="print">
      @if (localSheetData) {
        @for (sect of sheetDataTemplate; track sect.sectionId) {
          @if (sect.sectionTitle) {
            <p class="title" [ngClass]="sect.addetionalSectionTextClass">
              {{ sect.sectionTitle }}
            </p>
          }
          @for (note of sect.sectionNotes; track note) {
            <p class="note text-center">{{ note }}</p>
          }
          <div class="main-container">
            @for (table of sect.tables; track table.tableId) {
              <div class="grid-container">
                @if (table.title) {
                  <p class="title">{{ table.title }}</p>
                }
                <table class="sheet-table">
                  <thead>
                    @for (rowGroup of table.thead; track $index) {
                      @for (row of rowGroup; track $index) {
                        <tr class="header-row">
                          @for (cell of row; track $index) {
                            @if (cell.type === "td") {
                              <td
                                class="data-cell"
                                [attr.rowspan]="cell.rowspan"
                                [attr.colspan]="cell.colspan"
                                [ngClass]="cell.additionalClass"
                              >
                                {{ cell.value }}
                              </td>
                            }
                            @if (cell.type === "th") {
                              <th
                                class="header-data"
                                [attr.rowspan]="cell.rowspan"
                                [attr.colspan]="cell.colspan"
                                [ngClass]="cell.additionalClass"
                              >
                                {{ cell.value }}
                              </th>
                            }
                          }
                        </tr>
                      }
                    }
                  </thead>

                  <tbody>
                    @for (rowGroup of table.tbody; track $index) {
                      @for (row of rowGroup; track $index) {
                        <tr class="data-row">
                          @for (cell of row; track $index) {
                            @if (cell.content === "text") {
                              <td
                                class="data-cell"
                                [attr.rowspan]="cell.rowspan"
                                [attr.colspan]="cell.colspan"
                                [ngClass]="cell.additionalClass"
                              >
                                {{ cell.value }}
                              </td>
                            }
                            @if (cell.content === "input") {
                              <td
                                class="data-cell"
                                [class.disabled]="cell.disabled"
                                [ngClass]="cell.additionalClass"
                                [attr.rowspan]="cell.rowspan"
                                [attr.colspan]="cell.colspan"
                              >
                                @if (!cell.disabled) {
                                  <input
                                    [(ngModel)]="localSheetData[cell.id]"
                                    [id]="cell.id"
                                    (keydown)="readKey(cell.id, $event)"
                                    (ngModelChange)="
                                      onUpdateData(cell.id, $event)
                                    "
                                    class="data-input no-spin"
                                    [class.formula]="cell.isFormula"
                                    type="number"
                                  />
                                } @else if (cell.disabled && cell.id !== null) {
                                  <input
                                    [value]="localSheetData[cell.id]"
                                    [id]="cell.id"
                                    [disabled]="cell.disabled"
                                    [class.formula]="cell.isFormula"
                                    class="data-input no-spin"
                                    type="number"
                                  />
                                }
                              </td>
                            }
                          }
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        }
      }
    </div>
    <div class="bottom no-print">
      <button class="clear no-print" (click)="onClear()">Clear</button>
      <button class="print-cta no-print" (click)="onPrint()">Print</button>
      <button class="submit no-print" (click)="onSubmit()">
        Save / Submit
      </button>
    </div>
  }
</div>
